export interface TimelineEvent {
  year: number;
  text: string;
}

export interface TimelineSegment {
  id: number;
  title: string;
  startYear: number;
  endYear: number;
  events: TimelineEvent[];
}

export const segments: TimelineSegment[] = [
  {
    id: 1,
    title: "Наука",
    startYear: 2015,
    endYear: 2022,
    events: [
      {
        year: 2015,
        text: "13 сентября — частное солнечное затмение, видимое в Южной Африке и части Антарктиды",
      },
      {
        year: 2016,
        text: "Телескоп «Хаббл» обнаружил галактику GN-z11 — самую далёкую на тот момент",
      },
      {
        year: 2017,
        text: "Открытие гравитационных волн подтвердило предсказания общей теории относительности",
      },
      {
        year: 2018,
        text: "Учёные впервые отредактировали гены человеческих эмбрионов с помощью CRISPR",
      },
      {
        year: 2020,
        text: "Созданы первые стабильные квантовые вычислительные прототипы",
      },
      {
        year: 2022,
        text: "Получены новые данные о структуре тёмной материи",
      },
    ],
  },
  {
    id: 2,
    title: "Технологии",
    startYear: 2010,
    endYear: 2015,
    events: [
      {
        year: 2010,
        text: "Запуск первого iPad от Apple, изменившего рынок планшетов",
      },
      {
        year: 2011,
        text: "Активный рост облачных сервисов для бизнеса и разработчиков",
      },
      {
        year: 2012,
        text: "Ввод в эксплуатацию очистных сооружений на «СЕРВОЛЮКС АГРО»",
      },
      {
        year: 2013,
        text: "Массовое распространение LTE-сетей по всему миру",
      },
      {
        year: 2014,
        text: "Презентация Apple Watch — первого умного часового устройства от Apple",
      },
      {
        year: 2015,
        text: "Широкое внедрение DevOps-практик в IT-компаниях",
      },
    ],
  },
  {
    id: 3,
    title: "Медицина",
    startYear: 2018,
    endYear: 2020,
    events: [
      {
        year: 2018,
        text: "Первая успешная трансплантация лица в России",
      },
      {
        year: 2018,
        text: "Развитие персонализированной медицины на основе генома",
      },
      {
        year: 2019,
        text: "Разработка вакцины от COVID-19 началась в нескольких странах",
      },
      {
        year: 2019,
        text: "Искусственный интеллект начал применяться для диагностики заболеваний",
      },
      {
        year: 2020,
        text: "Массовое внедрение телемедицины во время пандемии",
      },
      {
        year: 2020,
        text: "Ускоренное одобрение новых вакцин и методов лечения",
      },
    ],
  },
  {
    id: 4,
    title: "Космос",
    startYear: 2005,
    endYear: 2010,
    events: [
      {
        year: 2005,
        text: "Запуск космического аппарата «Кассини» к Сатурну",
      },
      {
        year: 2006,
        text: "Понижение статуса Плутона до карликовой планеты",
      },
      {
        year: 2007,
        text: "Открытие большого количества экзопланет",
      },
      {
        year: 2008,
        text: "Первый частный космический корабль достиг орбиты",
      },
      {
        year: 2009,
        text: "Запуск телескопа Kepler для поиска экзопланет",
      },
      {
        year: 2010,
        text: "Подготовка программ для коммерческих космических полётов",
      },
    ],
  },
  {
    id: 5,
    title: "Экология",
    startYear: 2021,
    endYear: 2023,
    events: [
      {
        year: 2021,
        text: "Климатический саммит в Глазго: новые обязательства по сокращению выбросов",
      },
      {
        year: 2021,
        text: "Рост инвестиций в зелёные технологии",
      },
      {
        year: 2022,
        text: "Рекордное количество стран перешло на возобновляемые источники энергии",
      },
      {
        year: 2022,
        text: "Развитие технологий улавливания углерода",
      },
      {
        year: 2023,
        text: "Запуск крупнейшей программы по восстановлению лесов",
      },
      {
        year: 2023,
        text: "Расширение международных соглашений по защите океанов",
      },
    ],
  },
  {
    id: 6,
    title: "Искусство",
    startYear: 2012,
    endYear: 2018,
    events: [
      {
        year: 2012,
        text: "Открытие нового здания Музея современного искусства в Нью-Йорке",
      },
      {
        year: 2013,
        text: "Рост популярности цифровых инсталляций",
      },
      {
        year: 2015,
        text: "Цифровое искусство получило признание на крупных аукционах",
      },
      {
        year: 2016,
        text: "Художники начали активно использовать нейросети",
      },
      {
        year: 2017,
        text: "Виртуальная реальность стала инструментом для художников",
      },
      {
        year: 2018,
        text: "Первая выставка искусственного интеллекта в крупном музее",
      },
    ],
  },
];

